import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { StatementsComponent } from './pages/statements/statements.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.statements),
      component: StatementsComponent,
      canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class StatementsRoutingModule { }
